import Tithe from "#/components/exam-results/Tithe";
import { growthStatusGenerator } from "#/components/exam-results/views/type-3/overall/GeneralInfoHeader";

import type {  MultiLessonFlags } from "#/components/exam-results/types";
import type {  MainResultSet } from "#/services/rest/gwt/exam-results/views/type-1/multi-user.types";

import styles from "./styles.module.scss";

const MultiLessonCard = ({
  correctAnswers,
  mark,
  incorrectAnswers,
  noAnswers,
  name,
  flags,
  growthStatus,
  level,
  rank,
  tierNO
}: MainResultSet & { flags: MultiLessonFlags }) => {
  const growth = growthStatusGenerator(growthStatus, 14);

  return (
    <div className={styles["multiLessonCard"]}>
      <div className={styles["multiLessonCard__header"]}>
        <h2 className={styles["multiLessonCard__header-title"]}>{name}</h2>
        {flags.hasTithe && <Tithe tithe={tierNO} />}
      </div>
      <div className={styles["multiLessonCard__info"]}>
        <span>درصد:</span>
        <span dir="ltr">{mark} %</span>
      </div>
      {flags.isMulti && (
        <>
          <div className={styles["multiLessonCard__info"]}>
            <span>رتبه:</span>
            <span>{rank}</span>
          </div>
          <div className={styles["multiLessonCard__info"]}>
            <span>تراز:</span>
            <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
              <span>{level}</span>
              {growth !== null ? growth.icon : <></>}
            </div>
          </div>
        </>
      )}
      <div className={styles["multiLessonCard__stats"]}>
        <div className={styles["multiLessonCard__stats--correct"]}>
          <span>درست:</span>&nbsp;
          <span>{correctAnswers}</span>
        </div>
        <div className={styles["multiLessonCard__stats-separator"]} />
        <div className={styles["multiLessonCard__stats--wrong"]}>
          <span>غلط:</span>&nbsp;
          <span>{incorrectAnswers}</span>
        </div>
        <div className={styles["multiLessonCard__stats-separator"]} />
        <div className={styles["multiLessonCard__stats--unchecked"]}>
          <span>نزده:</span>&nbsp;
          <span>{noAnswers}</span>
        </div>
      </div>
    </div>
  );
};

export default MultiLessonCard;
